import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const GetChalanListByShop = createAsyncThunk(
  "sale/GetChalanListByShop",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/sale/list/${id}`);
    return data
  }
);

export const AddSale = createAsyncThunk(
  "sale/AddSale",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/sale/create/`, data)
    return response.data
  }
); 

export const UpdateSale = createAsyncThunk(
  "sale/UpdateSale",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/sale/update/${data.id}/`, data)
    return response.data
  }
);

// export const DeleteChalan = createAsyncThunk(
//   "sale/DeleteChalan",
//   async (id) => {
//     const response = await coreAxios.delete(`${BASE_URL}/api/sale/delete/${id}/`)
//     return response.status
//   }
// );

// export const GetChalanItems = createAsyncThunk(
//   "sale/GetChalanItems",
//   async (id) => {
//     const {data} = await coreAxios.get(`${BASE_URL}/api/sale/item/list/${id}/`)
//     return data
//   }
// );

// export const GetChalanDetail = createAsyncThunk(
//   "sale/GetChalanDetail",
//   async (id) => {
//     const {data} = await coreAxios.get(`${BASE_URL}/api/sale/detail/${id}/`)
//     return data
//   }
// );